export default __webpack_public_path__ + "f96095e72fce744a708eddf4f3bc187d.png";